/* Gliederung der Rechtstexte unter /policies/
 *
 * Die IT-Recht Kanzlei setzt Dienstnamen ohne jede Auszeichnung, und zwar auf
 * zwei Arten. Als eigener Absatz:
 *
 *     <p>- Apple Pay</p>
 *     <p>Shopify Analytics</p>
 *
 * und, haeufiger, als letzte Zeile des vorigen Absatzes hinter einem Umbruch:
 *
 *     <p>Weitere Hinweise zum Datenschutz bei Apple Pay ...<br> - Google Pay</p>
 *     <p>Wenn Sie sich fuer die Zahlungsart "Google Pay" entscheiden, ...</p>
 *
 * Der zweite Fall ist der schlimmere: der Name steht wirklich im vorigen Block,
 * sein eigener Text faengt erst im naechsten an. Optisch gehoert er damit zum
 * Falschen, und keine Absatzregel der Welt findet ihn.
 *
 * Regel deshalb wie vom Betreiber festgelegt: Beginnt eine Zeile mit einem
 * Strich, ohne blosse Folge eines Umbruchs im Fliesstext zu sein, steht davor
 * eine Leerzeile. Dazu die strichlosen Kurzzeilen, die dieselbe Rolle haben.
 *
 * Das Skript aendert keinen Text, fuegt keinen hinzu und entfernt keinen. Es
 * umschliesst vorhandene Knoten und setzt Klassen. Der Rechtstext bleibt exakt
 * das, was die Schnittstelle geliefert hat.
 */
(function () {
  var koerper = document.querySelector('.shopify-policy__body');
  if (!koerper) return;

  var STRICHE = '-‐‑‒–—−';

  function beginntMitStrich(text) {
    return text.length > 0 && STRICHE.indexOf(text.charAt(0)) !== -1;
  }

  /* Sieht der Text nach Dienstname aus statt nach Satz? */
  function istName(text) {
    var kern = beginntMitStrich(text) ? text.slice(1).trim() : text;
    if (!kern) return false;
    if (kern.length > 60) return false;
    if (kern.split(/\s+/).length > 5) return false;
    return !/[.!?;:,]$/.test(kern);
  }

  /* Fall 1: der ganze Absatz ist nur der Name. */
  var absaetze = koerper.querySelectorAll('p');
  for (var i = 0; i < absaetze.length; i++) {
    var p = absaetze[i];
    if (p.querySelector('b, strong, a')) continue;
    if (p.querySelector('br')) continue;
    var text = (p.textContent || '').replace(/\s+/g, ' ').trim();
    if (istName(text)) p.classList.add('policy-service');
  }

  /* Fall 2: der Name haengt hinter einem Umbruch am Absatzende. Alles ab dem
     Umbruch wandert in ein span, das als eigener Block gesetzt wird. Der
     Umbruch selbst wird dann still gelegt, sonst entstuende eine Zeile zu
     viel. */
  var umbrueche = koerper.querySelectorAll('p br');
  for (var j = 0; j < umbrueche.length; j++) {
    var br = umbrueche[j];
    var folgende = [];
    var k = br.nextSibling;
    var abbruch = false;

    while (k) {
      if (k.nodeType === 1 && k.tagName === 'BR') { abbruch = true; break; }
      folgende.push(k);
      k = k.nextSibling;
    }
    if (abbruch || !folgende.length) continue;

    var zeile = '';
    for (var n = 0; n < folgende.length; n++) {
      zeile += folgende[n].textContent || '';
    }
    zeile = zeile.replace(/\s+/g, ' ').trim();

    if (!beginntMitStrich(zeile)) continue;
    if (!istName(zeile)) continue;

    var huelle = document.createElement('span');
    huelle.className = 'policy-service';
    br.parentNode.insertBefore(huelle, folgende[0]);
    for (var m = 0; m < folgende.length; m++) huelle.appendChild(folgende[m]);
    br.classList.add('policy-service-br');
  }
})();
